import React, { Component } from 'react';
import {
  Button,
  ListGroup,
  ListGroupItem,
  Label,
  Input,
  FormGroup,
  Spinner
} from 'reactstrap';
import { withTranslation } from 'react-i18next';

import Confirm from './Confirm';
import constants from './constants';

class ListaAcoes extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modalCancellation: false,
      modalConfirmation: false,
      value: {},
      filterStatus: [constants.Status.PENDENTE]
    };

    this.handleFilter = this.handleFilter.bind(this);
    this.handleCancellation = this.handleCancellation.bind(this);
    this.handleConfirmation = this.handleConfirmation.bind(this);
    this.toggleModalConfirmation = this.toggleModalConfirmation.bind(this);
    this.toggleModalCancellation = this.toggleModalCancellation.bind(this);
  }

  componentDidMount() {
    this.props.actions.onLoad();
  }

  handleFilter(e) {
    let value = parseInt(e.target.value, 10);

    this.setState({
      filterStatus: [...this.state.filterStatus, value].filter(
        v => e.target.checked || value !== v
      )
    });
  }

  onStartReativate(value) {
    this.setState({
      modalConfirmation: true,
      value
    });
  }

  toggleModalConfirmation() {
    this.setState(({ modalConfirmation }) => ({
      modalConfirmation: !modalConfirmation
    }));
  }

  onStartApprove(value) {
    this.setState({ value });

    this.props.actions.onApprove({
      value
    }) /*.catch((v) => {
            alert(v.message);
        })*/;
  }

  onStartCancel(value) {
    this.setState({
      modalCancellation: true,
      value
    });
  }

  toggleModalCancellation() {
    this.setState(({ modalCancellation }) => ({
      modalCancellation: !modalCancellation
    }));
  }

  handleCancellation(text) {
    this.toggleModalCancellation();

    let value = this.state.value;

    this.props.actions.onCancel({
      value,
      text
    }) /*.catch((v) => {
            alert(v.message);
        })*/;
  }

  handleConfirmation() {
    this.toggleModalConfirmation();

    let value = this.state.value;

    this.props.actions.onCreate({
      value,
      isNew: false
    }) /*.catch((v) => {
            alert(v.message);
        })*/;
  }

  tactions (action, {tipo:tipo1, status}) {
    let { tipo, t } = this.props;

    return t([
      tipo + "-" + tipo1 + ":status." + status + ".actions." + action,
      tipo + "-" + tipo1 + ":actions." + action,
      tipo + ":status." + status + ".actions." + action,
      tipo + ":actions." + action,
      "listaAcoes:actions." + action
    ]);
  }

  render() {
    let {
      value: { result, fetching, errors },
      labelFn,
      tipo = "listaAcoes",
      t,
      title = t([tipo + ":title"]),
    } = this.props;
    let {
      modalCancellation,
      modalConfirmation,
      value,
      filterStatus
    } = this.state;

    let items = result.filter(v => ~filterStatus.indexOf(v.status));

    return (
      <div>
        <ListGroup>
          {title && <ListGroupItem color="dark">{title}</ListGroupItem>}
          <ListGroupItem>
            {Object.keys(constants.Status).map((v, i) => {
              return (
                <FormGroup key={i} check inline>
                  <Label check>
                    <Input
                      type="checkbox"
                      onChange={this.handleFilter}
                      value={constants.Status[v]}
                      checked={!!~filterStatus.indexOf(constants.Status[v])}
                    />{' ' + t([tipo + ":status." + v, "listaAcoes:status." + v])}
                  </Label>
                </FormGroup>
              );
            })}
          </ListGroupItem>
          {items.map((v, i) => {
            return (
              <ListGroupItem
                key={i}
                className="lcr-container-row d-flex justify-content-between align-items-center"
                color={['danger', 'warning', ''][1 + v.status]}
              >
                {labelFn(v, t)}
                <div className="text-right">
                  {(1 !== fetching || value !== v) &&
                    constants.Status.CANCELADA === v.status && (
                      <Button
                        color="success"
                        onClick={() => {
                          this.onStartReativate(v);
                        }}
                        className="lcr-button-reativar"
                        title={this.tactions("reactivate", v)}
                      >
                        <span className="fa fa-check" />{' '}
                        <span className="d-none d-sm-inline-block">
                        {this.tactions("reactivate", v)}
                        </span>
                      </Button>
                    )}
                  {(1 !== fetching || value !== v) &&
                    constants.Status.PENDENTE === v.status && (
                      <Button
                        color="info"
                        onClick={() => {
                          this.onStartApprove(v);
                        }}
                        className="lcr-button-ativar"
                        title={this.tactions("activate", v)}
                      >
                        <span className="fa fa-check" />{' '}
                        <span className="d-none d-sm-inline-block">
                        {this.tactions("activate", v)}
                        </span>
                      </Button>
                    )}
                  {(1 !== fetching || value !== v) &&
                    -1 <
                      [
                        constants.Status.CONFIRMADA,
                        constants.Status.PENDENTE
                      ].indexOf(v.status) && (
                      <Button
                        color="danger"
                        onClick={() => {
                          this.onStartCancel(v);
                        }}
                        className="lcr-button-desativar"
                        title={this.tactions("deactivate", v)}
                      >
                        <span className="fa fa-times" />{' '}
                        <span className="d-none d-sm-inline-block">
                        {this.tactions("deactivate", v)}
                        </span>
                      </Button>
                    )}
                </div>
              </ListGroupItem>
            );
          })}
          {1 === fetching && (
            <ListGroupItem color="dark"><Spinner size="sm" color="dark" /> Obtendo lista...</ListGroupItem>
          )}
          {2 === fetching && !items.length && (
            <ListGroupItem color="success">
              Não há registros para o filtro selecionado.
            </ListGroupItem>
          )}
          {errors.map((error, i) => (
            <ListGroupItem key={i} color="danger">
              {error}
            </ListGroupItem>
          ))}
        </ListGroup>
        <Confirm
          headerText="Confirmar desativação do registro"
          labelText="Confirma desativação?"
          isOpen={modalCancellation}
          toggle={this.toggleModalCancellation}
          onConfirm={this.handleCancellation}
        />
        <Confirm
          headerText="Confirmar reativação do registro"
          labelText="Confirma reativação?"
          isOpen={modalConfirmation}
          toggle={this.toggleModalConfirmation}
          onConfirm={this.handleConfirmation}
        />
      </div>
    );
  }
}

export default withTranslation(null, {withRef:true})(ListaAcoes);


// WEBPACK FOOTER //
// ./src/components/ListaAcoes.js